<template>
  <div id="dropdown-component">
    <div class="form-group">
      <label v-if="label !== ''" :for="name">
        {{ label }}
        <span v-if="mandatory" class="text-danger"> * </span>
      </label>
      <select
        :id="`${name}-${index || ''}`"
        :name="name"
        :value="modelValue"
        class="form-control"
        :class="`form-control-${size} ${
          fieldState === false ? 'is-invalid' : ''
        }`"
        :disabled="isDisable"
        @change="$emit('changeEvent', name, index)"
        @input="$emit('update:modelValue', $event.target.value)"
      >
        <template v-for="(option, idx) in options">
          <option
            v-if="!option.value || option.value === 'null'"
            :key="option.value"
            value=""
            :selected="true"
            :disabled="true"
          >
            {{ option.text }}
          </option>
          <option
            v-else
            :key="idx"
            :value="option.value"
            :selected="false"
          >
            {{ option.text }}
          </option>
        </template>
      </select>
      <!-- display error messages -->
      <error-message-new :index="index" :errors="errors" :fieldName="name" />
    </div>
  </div>
</template>

<script>
import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  name: 'Yearpicker',
  props: {
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    yearRange: {
      type: String,
      default: `1900-${new Date().getFullYear()}`,
    },
    placeholder: {
      type: String,
      default: "Select Year Of Birth",
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    mandatory: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    options() {
      let splitYear = this.yearRange.toString().split("-");
      let options = [{ text: this.placeholder, value: null }];

      for (let i = splitYear[0]; i <= splitYear[1]; i++) {
        options.push({ text: i, value: i });
      }

      return options;
    },
    fieldState() {
      return (
        this.$hasField({
          name: this.name,
          errors: this.errors,
          index: this.index,
          parent: this.parent,
        }) && this.showError
      );
    },
  },
  watch: {
    value: {
      handler(val) {
        this.localValue = val;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: { $hasField, handleFieldState },
};
</script>

<style></style>
